import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { LoadingService } from '@core/services/loading/loading-api';
import { catchError, finalize, takeUntil } from 'rxjs/operators';
import { ToastService } from '@core/services/toast-api';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private ngUnsubscribe = new Subject();
  private totalRequests = 0;
  private isDisabled = false;
  private originalAPILists: string[] = [];
  private duplicatesAPIRequest: string[] = [];
  private FilteredUniqueAPILists = new Map();

  constructor(private loadingService: LoadingService,
    private toastService: ToastService,
    private router: Router
  ) {
    this.loadingService.isDisabled$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (data) => (this.isDisabled = data),
      });
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.headers.has("skip")) {
      request = request.clone({
        headers: request.headers.delete('skip')
      });
      return next.handle(request);
    }
    //Logic for finding of Duplicate calls START
    this.originalAPILists.push(request.urlWithParams)
    if (this.FilteredUniqueAPILists.has(request.urlWithParams) &&
      !request.url.toLowerCase().includes('notificationscount')) {
      this.duplicatesAPIRequest.push(request.urlWithParams);
    }
    else {
      this.FilteredUniqueAPILists.set(request.urlWithParams, request.params)
    }
    //END

    if ((request.url.toLowerCase().includes('count') && !request.url.toLowerCase().includes('picounts'))
      || (request.url.toLowerCase().includes('message') && !request.url.toLowerCase().includes('messages'))
      || request.url.toLowerCase().includes('notifications')
      || request.url.toLowerCase().includes('basicactivitylog')
      || request.url.toLowerCase().includes('/image')
      || request.url.toLowerCase().includes('api/product/stockroomInfo')
      || request.url.toLowerCase().includes('availablecount')
      || (request.url.toLowerCase().includes('news') && !this.router.url.includes('/admin/organization/news')) || request.url.toLowerCase().includes('softwares')
      || request.url.toLowerCase().includes('predefined')
      || request.url.toLowerCase().includes('/user/massdelete')
      || request.url.toLowerCase().includes('products/qi/upload/status')
    ) {
      return next.handle(request);
    }

    // Skip loader for manage stockroom page requests
    else if (this.router.url.includes('/administration/manage-stockroom/') && !request.url.toLowerCase().includes('organization/shipTos')
    ) {
      return next.handle(request);
    }


    this.totalRequests++;
    if (!this.isDisabled) {
      this.loadingService.setLoading(true);
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!this.isDisabled) {
          this.loadingService.setLoading(false);
        }
        return throwError(error);
      }),
      finalize(() => {
        this.totalRequests--;
        if (this.duplicatesAPIRequest.length > 0 && window.location.hostname === 'localhost') {
          // this.toastService.show('error', 'We have duplicate API calls on this page, Please check console for details or contact to Dev team.', undefined, true, 10000);
          // console.log('Lists of Duplicate Calls on Current Page', this.duplicatesAPIRequest);
        }
        if (this.totalRequests <= 0) {
          this.originalAPILists = []
          this.FilteredUniqueAPILists.clear();
          this.duplicatesAPIRequest = [];
          if (!this.isDisabled) {
            this.loadingService.setLoading(false);
          }
        }
      })
    );
  }
}
